import axios from "fetch-api/fetch-api";
import PASentry from "../../util/pa-sentry";
import { IModel } from "../interfaces/garage-apis";

export function getModelsByYearMake(year: number, make: string) {
  if (year && make) {
    return axios.get<IModel[]>("/get-models-by-year-make-v3", {
      params: {
        year,
        make,
      },
    });
  }
  const error = new Error("year && make not present in get-models-by-year-make-v3");
  PASentry.logException(error, {}, { });
  return Promise.reject(error);
}
